/** Se o onboarding já foi visto, e por quem.
 *
 * Guardado no `localStorage` **por tenant**, e não num campo do banco. A
 * escolha é deliberada e reversível: o onboarding é ajuda de primeira vez, não
 * regra de negócio, e criar coluna, migration e rota para lembrar disso seria
 * caro para algo que ninguém audita. Se um dia importar saber quem concluiu —
 * para medir ativação, por exemplo —, aí sim vira dado do produto.
 *
 * **Por tenant** porque a mesma pessoa pode abrir mais de uma empresa no mesmo
 * navegador: quem já viu o guia na Acme não precisa revê-lo, mas quem acabou
 * de criar a segunda conta está começando de novo ali.
 *
 * O efeito de perder isso é benigno: o guia reaparece, e ele é dispensável em
 * um clique.
 */

const PREFIXO = "tanzuh:onboarding:";

function chave(tenantId: string): string {
  return `${PREFIXO}${tenantId}`;
}

export function onboardingConcluido(tenantId: string): boolean {
  try {
    // Sem `?.`: o tipo garante que `localStorage` existe, e o ESLint recusa a
    // verificação morta. O que precisa ser tratado é o `throw` no acesso — não
    // a ausência do objeto —, e é isso que o `catch` faz.
    return globalThis.localStorage.getItem(chave(tenantId)) === "1";
  } catch {
    // `localStorage` lança em navegação privada de alguns navegadores e com
    // cookies de terceiros bloqueados. Tratar como "não concluído" mostra o
    // guia de novo, que é o lado inofensivo do erro.
    return false;
  }
}

export function marcarOnboardingConcluido(tenantId: string): void {
  try {
    globalThis.localStorage.setItem(chave(tenantId), "1");
  } catch {
    // Sem persistência, o guia reaparece no próximo acesso. Não é motivo para
    // interromper quem acabou de terminá-lo.
  }
}
